"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cedula_1 = require("./utils/cedula");
exports.vRequired = (value) => !!value || 'Campo Obligatorio.';
exports.vMin = (min) => (value = '') => value.length >= min || `Mínimo ${min} caracteres`;
exports.vEmail = (value = '') => {
    const pattern = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value.trim()) || 'E-mail inválido.';
};
exports.vIntOrDouble = (v = '') => {
    const pattern = /^[0-9]+([.][0-9]{2}?)?$/;
    return pattern.test(v.trim()) || 'Valor no valido';
};
exports.vOnlyInt = (v = '') => {
    const pattern = /^[0-9]*$/;
    return pattern.test(v.trim()) || 'Valor no valido';
};
exports.vOnlyLetters = (v = '') => /^[a-zA-ZÀ-ú\s]*$/.test(v.trim()) || 'Valor invalido';
exports.vPhoneRules = (v = '') => /^((\+)([0-9]{1,3})([0-9]{9-20}))|([0-9]{9,20})$/.test(v.trim()) || 'Número Inválido';
exports.vCedula = (v = '') => {
    const patron = /^([0][0-9]|[1][0-9]|[2][0-4]{1})([0-5]{1})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{1})$/;
    if (patron.test(v.trim())) {
        const resultado = cedula_1.validarCedula(v.trim());
        return resultado;
    }
    else {
        return 'Ingrese su número de cédula';
    }
};
exports.vRuc = (v = '') => {
    const patron = /^([0][0-9]|[1][0-9]|[2][0-4]{1})([0-5]{1})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{1})([0]{1})([0]{1})([1]{1})$/;
    if (patron.test(v.trim())) {
        const resultado = cedula_1.validarCedula(v.trim().substring(0, 10), 'El ruc ingresado es incorrecto');
        return resultado;
    }
    else {
        return 'Ingrese tu número de ruc';
    }
};
exports.vCedulaOrRuc = (v = '') => {
    if (v.length > 10) {
        return exports.vRuc(v);
    }
    else {
        return exports.vCedula(v);
    }
};
//# sourceMappingURL=index.js.map